import { useContentSelector } from '@wajeez-web/stores/content';

export const useGetContentEntityStructuresLookups = () => {
  return useContentSelector(
    ({ contentEntityStructures }) => contentEntityStructures.lookups
  );
};
